import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { subscribeNetwork } from '../offline/network';
import { prefetchReferenceData, pruneSyncedRecords, refreshCodeCounter, refreshUsersFile } from '../offline/sync';

// يعمل في الخلفية: ينزّل البيانات المرجعية وعدّاد الأرقام وملف المستخدمين مع الاتصال.
// رفع فحوصات الجهاز يدوي فقط (زر ↻ أو صفحة فحوصات الجهاز)، فلا رفع هنا.
export default function SyncManager() {
  const { user } = useAuth();
  const userId = user?.id;
  const auctionId = user?.selected_auction_id;

  useEffect(() => {
    if (!userId) return undefined;

    // تنظيف آثار الفحوصات المرفوعة القديمة، مع الاتصال أو دونه.
    pruneSyncedRecords();

    const runOnline = async () => {
      // العدّاد لكل مستخدم ومزاد، فيُحدَّث في كل مرة؛ البيانات المرجعية مشتركة فتُنزَّل كل فترة.
      await Promise.all([prefetchReferenceData(), refreshCodeCounter(), refreshUsersFile()]);
    };

    runOnline();
    return subscribeNetwork((offline) => {
      if (!offline) runOnline();
    });
  }, [userId, auctionId]);

  return null;
}
